import {
  FaLocationDot,
  FaArrowRight,
} from "react-icons/fa6";
import {
  MapPin,
  Mail,
  Phone,
} from "lucide-react";
import socialLinks from "../data/socialLinks";
import FooterForm from "./Footerform";

function Footer() {
  
  return (
    <footer className="bg-gradient-to-br from-[#0B1023] via-[#171E3B] to-[#231B52] text-white pt-20" id="contact">

      {/* Heading */}

      <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center">

  <span className="inline-block px-3 py-1.5 sm:px-5 sm:py-2 rounded-full bg-pink-500/20 border border-pink-500/30 text-pink-300 text-[11px] sm:text-sm font-semibold tracking-wide">
    LET'S BUILD TOGETHER
  </span>

  <h2 className="mt-3 sm:mt-6 text-2xl sm:text-4xl md:text-5xl font-bold leading-tight">
    Ready to Grow Your Business?
  </h2>

  <p className="mt-3 sm:mt-5 max-w-xl sm:max-w-2xl mx-auto text-[13px] sm:text-base text-gray-300 leading-6 sm:leading-8 px-2 sm:px-0">
    Tell us about your project. Our experts will contact you within
    24 hours with the best solution for your business.
  </p>

</div>

      {/* Contact Form */}

    <FooterForm/>

      {/* Footer Content */}

      <div className="max-w-6xl mx-auto px-6 mt-16">

      <div className="border-t border-white/10 pt-8 sm:pt-12 grid lg:grid-cols-3 gap-8 sm:gap-12">

          {/* Brand */}

          <div>

          <h2 className="text-3xl sm:text-4xl font-bold">
              Grow<span className="bg-gradient-to-r from-fuchsia-600 via-purple-600 to-pink-500 bg-clip-text text-transparent">X</span>
            </h2>

            <p className="text-gray-300 mt-3 sm:mt-5 text-[13px] sm:text-base leading-6 sm:leading-8">
              GrowX is a digital growth agency helping startups and
              businesses scale through Web Development, AI Automation,
              Digital Marketing and Mobile Apps.
            </p>

            {/* Social */}

            <div className="flex gap-3 sm:gap-4 mt-5 sm:mt-8">

              {socialLinks.map((item, index) => {

                const Icon = item.icon;

                return (

                  <a
                    key={index}
                    href={item.link}
                    target="_blank"
                    rel="noreferrer"
                className="group w-9 h-9 sm:w-11 sm:h-11 rounded-full bg-white/10 border border-white/10 flex items-center justify-center transition-all duration-300 hover:bg-gradient-to-r hover:from-fuchsia-600 hover:via-purple-600 hover:to-pink-500 hover:-translate-y-1 hover:shadow-lg"
                  >
                   <Icon className="w-4 h-4 sm:w-5 sm:h-5" fill="#fff" />
                  </a>

                );

              })}

            </div>

          </div>

          {/* Quick Links */}

          <div>

          <h3 className="text-lg sm:text-xl font-semibold mb-4 sm:mb-6">
              Quick Links
            </h3>

            <ul className="space-y-2 sm:space-y-4">

              {[
                "Services",
                "About",
                "Projects",
                "Testimonial",
                "Contact",
              ].map((item) => (

                <li key={item}>

                  <a
                    href={`#${item.toLowerCase()}`}
                   className="flex items-center gap-2 sm:gap-3 text-[13px] sm:text-base text-gray-300 hover:text-pink-400 duration-300"
                  >
                   <FaArrowRight className="text-[10px] sm:text-xs" />

                    {item}

                  </a>

                </li>

              ))}

            </ul>

          </div>

          {/* Contact */}

          <div>

          <h3 className="text-lg sm:text-xl font-semibold mb-4 sm:mb-6">
              Contact Us
            </h3>

            <div className="space-y-4 sm:space-y-5">

            {/* Address */}
            <div className="flex items-start gap-3 sm:gap-4">
            <MapPin className="mt-1 h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0 text-pink-500" />

            <p className="text-[13px] sm:text-base text-gray-300 leading-6 sm:leading-7">
                Ground Floor, Plot No.17,<br />
                New Bharat Colony,<br />
                Mata Amritanandmayi Marg,<br />
                Faridabad, Haryana - 121002
              </p>
            </div>

            {/* Email */}
            <div className="flex items-center gap-3 sm:gap-4">
            <Mail className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0 text-pink-500" />
              <a
                href="mailto:growx@samrattechitsolutions.com"
                className="text-[13px] sm:text-base text-gray-300 hover:text-white transition break-all"
              >
                growx@samrattechitsolutions.com
              </a>
            </div>

            {/* Phone */}
            <div className="flex items-start gap-3 sm:gap-4">
            <Phone className="mt-1 h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0 text-pink-500" />

            <div className="text-[13px] sm:text-base text-gray-300 leading-6 sm:leading-7">
                <p>+91 8802642136</p>
                <p>+91 9598491005</p>
              </div>
            </div>

            </div>

          </div>

        </div>

      </div>

      {/* Bottom */}

      <div className="border-t border-white/10 mt-16">

      <div className="max-w-6xl mx-auto px-4 md:px-6 py-6 border-t border-white/10">
  <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">

    {/* Copyright */}
    <p className="text-center md:text-left text-sm text-gray-400">
      © 2026 GrowX. All Rights Reserved by{" "}
      <span className="text-gray-400">
        Samrat Tech IT Solutions
      </span>.
    </p>

    {/* Links */}
    <div className="flex flex-wrap justify-center md:justify-end gap-5 text-sm">
      <a
        href="/"
        className="text-gray-400 transition hover:text-purple-400"
      >
        Privacy Policy
      </a>

      <a
        href="/"
        className="text-gray-400 transition hover:text-purple-400"
      >
        Terms & Conditions
      </a>

      <a
        href="/"
        className="text-gray-400 transition hover:text-purple-400"
      >
        Cookies
      </a>
    </div>

  </div>
</div>

      </div>

    </footer>
  );
}

export default Footer;